export default "__VITE_ASSET__BjPy9df5__"